import { render, staticRenderFns } from "./sliding-panel.vue?vue&type=template&id=0f095edb&"
import script from "./sliding-panel.vue?vue&type=script&lang=ts&"
export * from "./sliding-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f095edb')) {
      api.createRecord('0f095edb', component.options)
    } else {
      api.reload('0f095edb', component.options)
    }
    module.hot.accept("./sliding-panel.vue?vue&type=template&id=0f095edb&", function () {
      api.rerender('0f095edb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/_sliding-panel/sliding-panel.vue"
export default component.exports